/**
 * Created by mac on 2017/12/19.
 * @desc 常用参数工具函数
 */

const params = {
    getUrlParam: (str, url) => {
        const re = new RegExp('(^|\\?|&)' + str + '=([^&^#]+)(&|$|#)', 'i');
        url = url || window.location.href;
        const m = url.match(re);
        if (m) {
            return m[2];
        }
        return '';
    },
    //获取所有url参数
    getAllUrlParam: () => {
        var name,
            value,
            params = {};
        var str = location.href; //取得整个地址栏
        var num = str.indexOf('?');
        str = str.substr(num + 1); //取得所有参数   stringvar.substr(start [, length ]

        var arr = str.split('&'); //各个参数放到数组里
        for (var i = 0; i < arr.length; i++) {
            num = arr[i].indexOf('=');
            if (num > 0) {
                name = arr[i].substring(0, num);
                value = arr[i].substr(num + 1);
                params[name] = value;
            }
        }
        return params;
    },
    /**
     * 替换模版
     * @param { xxx{a}xxx } template  
     * @param { a: value } param 
     */
    tempEngine: (template, param) => {
        const pattern = /\{(\w*[:]*[=]*\w+)\}(?!})/g;
        return template.replace(pattern, (match, key) => {
            return param[key] || '';
        });
        // let ctx = template;
        // if (
        //     _.isObject(param) &&
        //     typeof param === 'object' &&
        //     /{([\s\S]+?)}/g.test(template)
        // ) {
        //     ctx = _.template(template, { interpolate: /{([\s\S]+?)}/g })(param);
        // }
        // return ctx;
    }
};

export default params;



// WEBPACK FOOTER //
// ./src/util/params.js